import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'

import { fadeIn } from '../../SearchNearParking.styled'

export const OptionsWrapper = styled.div`
  display: flex;
  max-width: 1024px;
  margin: 0 auto;
  padding: 10px 8px 10px 10px;
  align-items: center;
  gap: 16px;
  border-radius: 36px;
  background: #fff;
  border: 2px solid #093769;
  width: 340px;
  box-shadow: 0px 8px 32px 0px rgba(9, 55, 105, 0.16);

  ${mediaUp('md')} {
    padding: 8px 8px 8px 36px;
    max-width: 1024px;
    width: unset;
    gap: 12px;
    box-shadow: 0px 8px 32px 0px rgba(9, 55, 105, 0.16);
    border: unset;
  }
  ${mediaUp('lg')} {
    padding: 8px 8px 8px 36px;
    gap: 36px;
  }
`

export const MobileSearchBoxWrapper = styled.div<{
  isFixed?: boolean
  isVisible?: boolean
}>`
  background: ${({ isFixed }) =>
    isFixed
      ? 'linear-gradient(to bottom, #093769 50%, rgba(255, 255, 255, 0) 50%);'
      : 'transparent'};
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'relative')};
  top: ${({ isFixed }) => (isFixed ? '42px' : 'unset')};
  animation: ${({ isVisible }) => (isVisible ? fadeIn : 'none')} 0.3s
    ease-in-out;
  width: ${({ isFixed }) => (isFixed ? '100vw' : 'unset')};
  padding: ${({ isFixed }) => (isFixed ? '8px' : 'unset')};
  box-sizing: border-box;
  opacity: ${({ isVisible, isFixed }) => (isFixed ? (isVisible ? 1 : 0) : 1)};
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  transform: translateY(${({ isVisible }) => (isVisible ? '0' : '-100%')});
`

export const MobileSearchWrapper = styled.div`
  display: grid;
  gap: 4px;
`

export const LocationText = styled.div`
  font-size: 12px;
  color: #0b4684;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaUp('lg')} {
    font-weight: 600;
  }
`

export const DateText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #6c7075;

  ${mediaUp('lg')} {
    font-weight: 600;
  }
`
